"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@emotion/react");
const react_2 = __importDefault(require("react"));
const Global = ({ styles, ...rest }) => {
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(react_1.Global, { ...rest, styles: {
            ...styles,
            '*': {
                'boxSizing': 'border-box',
                'fontFamily': theme.typography.fontFamily,
                'fontWeight': theme.typography.fontWeightLight,
                'fontSize': theme.typography.fontSize.medium,
                '::-webkit-scrollbar': {
                    width: '7px'
                },
                '::-webkit-scrollbar-track': {
                    backgroundColor: theme.palette.colors.whisper
                },
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: theme.palette.colors.linkWater2,
                    borderRadius: '3.5px',
                    width: '7px'
                }
            },
            'html, body': {
                margin: 0,
                padding: 0
            }
        } }));
};
exports.default = react_2.default.memo(Global);
//# sourceMappingURL=index.js.map